define('drops/image/image',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq',
    'lq/util',
    'lq/onlongpress'
], function ($, Drop, Style, lq, util, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            selectedResizeOption: 'fill',
            openInline: false,
            cropImageWidth: 150,
            cropImageHeight: 150,
            cropPositionX: 0,
            cropPositionY: 0,
            backgroundRepeat: true,
            opacity: 100,
            notOptimise: false,
            optimisationLevel: 0
        }
    };

    function Image(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.$image = $('<div />')
            .css({
                'width': '100%',
                'height': '100%',
                'overflow': 'hidden'
            })
            .attr('title', this.data.title)
            .attr('tabindex', this.data.tabIndex)
            .appendTo(this.$element);

        this.$element
            .addClass('boxToBorderSize');

        Style.renderStyles(this, null, this.$image);

        this.applyEventTrigger('mouseEnter', 'mouseenter');
    };

    Drop.extend(Image, Drop);

    Image.typeName = 'Image';

    Image.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        this.setImageScaling(this.data.selectedResizeOption);

        var imagePath = this.getImagePath();
        if (imagePath)
            this.setImage(imagePath);

        // This property is here for backwards compatibility.
        // Ignore it when the value was left untouched,
        // otherwise it will overwrite the value from styling
        if (this.data.opacity !== 100)
            this.setOpacity(this.data.opacity);

        this.initialize();
        this.applyPosition();
    };

    Image.prototype.getImagePath = function () {
        if (this.data.physicalFile)
            return lq.getTenantUploads(this.data.physicalFile);

        // non-editable property used on generated images like default preloader on list
        if (this.data.cdnPath)
            return lq.getCdnUrl(this.data.cdnPath);

        return null;
    };

    Image.prototype.setImage = function(path) {
        this.$image.css('background-image', 'url(' + path + ')');
    };

    Image.prototype.initialize = function() {
        var self = this;

        if (this.data.hyperlink) {
            this.data.hyperlink = util.convertRelativeHyperlinkToHostName(this.data.hyperlink);

            this.$image
                .addClass('clickable')
                .on('click', function (event) {
                    window.open(self.data.hyperlink, self.data.openInline ? '_self' : '_blank');
                    event.stopPropagation();
                });
        }

        if (!this.designData && this.isEventEnabled('onLongPress')) {
            this.$image.addClass('clickable');
            OnLongPress.applyLongPressOnElement(this.$element, this);
        } else if (this.data.eventing && this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            this.$image
                .addClass('clickable')
                .on('keypress', function (e) {
                    if (e.keyCode === 13)
                        self.triggerEvent(self.data.eventing.clicked.raisedEventName);
                });
            this.applyEventTrigger('clicked', 'click', this.$image);
        }
    };

    Image.prototype.setOpacity = function(opacity) {
        this.$image.css({ opacity: opacity / 100 });
    };

    // todo unify Image and DynamicImage
    Image.prototype.setImageScaling = function (resizeOption) {
        if (resizeOption === 'fill') {
            this.$image.css('background-size', '100% 100%');
        } else if (resizeOption === 'fillKeepRatio') {
            this.$image.css('background-size', 'cover');
        } else if (resizeOption === 'crop') {
            this.$image.css('background-size', this.data.cropImageWidth + 'px' + ' ' + this.data.cropImageHeight + 'px');
        } else if (resizeOption === 'completeImageKeepRatio') {
            this.$image.css({
                'background-size': 'contain',
                'background-repeat': 'no-repeat',
                'background-position': this.data.horizontalImageAlignment + ' ' + this.data.verticalImageAlignment
            });
        }

        //somehow offset doesn't work with center px center px

        var str = 'calc(' +
            this.getPercentage(this.data.backgroundAnchorX) +
            ' + ' +
            this.data.cropPositionX +
            'px) calc(' +
            this.getPercentage(this.data.backgroundAnchorY) +
            ' + ' +
            this.data.cropPositionY +
            'px)';

        this.$image.css('background-position', str);

        this.$image.css('background-repeat', this.data.backgroundRepeat ? 'repeat' : 'no-repeat');
    };

    Image.prototype.getPercentage = function(value)
    {
        switch (value) {
            case 'left':
                return '0%';
            case 'center':
                return '50%';
            case 'right':
                return '100%';
            case 'top':
                return '0%';
            case 'bottom':
                return '100%';
            default:
                return '50%' ;
        }
    };

    return Image;
});
